export default {"src":"/_next/static/media/checkboxBuyers.ac78bf24.svg","height":16,"width":16};